export const API_URL = 'https://api.snsratings.uz'